export default {
  label: 'Canales',
  placeholder: 'Todos',
};
